module.exports = __webpack_public_path__ + "img/wallet-active.5b6271ae.svg";